<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zQ6gEK/tc-custom/9780814797280.jpg?1719927000778" alt="This image is the cover for the book Gangsters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gangsters
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Why young people participate in violent gang behavior</b><br/><br/>The effects of gang violence are witnessed every day on the streets, in the news, and on the movie screen. In all these forums, gangs of young adults are associated with drugs and violence. Yet what is it that prompts young people to participate in violent behavior? And what can be done to extract adolescents from the gangster world of crime, death, and incarceration once they have become involved?<br/><br/> In <b>Gangsters: 50 Years of Madness, Drugs, and Death on the Streets of America</b>, Lewis Yablonsky provides answers to the most baffling and crucial questions regarding gangs. Using information gathered from over forty years of experience working with gang members and based on hundreds of personal interviews, many conducted in prisons and in gang neighborhoods, Yablonsky explores the pathology of the gangsters' apparent addiction to incarceration and death.<br/><br/><b>Gangsters</b> is divided into four parts, including a brief history of gangs, the characteristics of gangs, successful approaches for treating gangsters in prison and the community, and concluding with a review and analysis of notable behavioral and social scientific theories of gangs. While condemning their violent behavior in no uncertain terms, Yablonsky offers hope through his belief that, given a chance in an effective treatment program, youths trapped in violent behavior can change their lives in positive ways and, in turn, facilitate positive change in their communities and society at large.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lewis Yablonsky
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c000c78